import React from "react";
import { useNavigate } from "react-router-dom";
import DeminimisDashboard from "./deminimis/DeminimisDashboard";
import DeminimisPageLayout from "./deminimis/DeminimisPageLayout";
import RoleGuard from "../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../auth/roles";
import AccessDenied from "./ui/AccessDenied";

const Deminimis = ({ role }) => {
  const navigate = useNavigate();

  return (
    <RoleGuard
      moduleKey={MODULES.DEMINIMIS}
      roles={ROLE_GROUPS.ALL}
      fallback={<AccessDenied />}
    >
      <DeminimisPageLayout title="De minimis" lg={9} md={10}>
        <DeminimisDashboard
          onOpenAdd={() => navigate("/Deminimis/Dodaj")}
          onOpenDetails={(id) => navigate(`/Deminimis/Podrobnosti/${id}`)}
        />
      </DeminimisPageLayout>
    </RoleGuard>
  );
};

export default Deminimis;
